import { SurfaceRuntimeError } from './errors.js';
let installed = null;
/**
 * Install the document's one host. The loader calls it before it mounts the root.
 *
 * Throws {@link SurfaceRuntimeError} `host-already-installed` when a host is already installed,
 * and keeps the first host, so a document has one binder. Side effect: fills the module-level slot.
 */
export function installSurfaceHost(host) {
    if (installed !== null) {
        throw new SurfaceRuntimeError('host-already-installed', 'a surface host is already installed in this document');
    }
    installed = host;
}
/** True once {@link installSurfaceHost} has run in this document. Pure read. */
export function hasSurfaceHost() {
    return installed !== null;
}
/**
 * The installed host, for `mountSurface`. Throws {@link SurfaceRuntimeError} `host-missing` when
 * none is installed. Not exported from `./v1`.
 */
export function requireSurfaceHost() {
    if (installed === null) {
        throw new SurfaceRuntimeError('host-missing', 'no surface host is installed; the loader installs one before it mounts');
    }
    return installed;
}
/** Empty the slot. `resetSurfaceRuntime` in `./testing` is the only caller. */
export function resetSurfaceHost() {
    installed = null;
}
//# sourceMappingURL=host.js.map